export default __webpack_public_path__ + "9faeb9e59cbd9f7d2dfb8c61cb2ee812.png";